// Application Constants

export const APP_CONFIG = {
  name: 'Andrew Knight',
  description: 'Senior Software Engineer Portfolio',
  version: '1.0.0',
} as const;

// API Configuration
export const API_CONFIG = {
  baseUrl: process.env.PUBLIC_URL || '',
  dataEndpoint: '/site-data.json',
  cacheDuration: 5 * 60 * 1000, // 5 minutes
  timeout: 10000, // 10 seconds
} as const;

// Animation Configuration
export const ANIMATION_CONFIG = {
  duration: {
    fast: 0.2,
    normal: 0.5,
    slow: 0.8,
  },
  stagger: {
    fast: 0.1,
    normal: 0.2,
    slow: 0.3,
  },
  easing: {
    easeOut: 'easeOut',
    easeIn: 'easeIn',
    easeInOut: 'easeInOut',
  },
} as const;

// Theme Configuration
export const THEME_CONFIG = {
  modes: ['light', 'dark', 'system'] as const,
  defaultMode: 'system' as const,
  localStorageKey: 'theme-preference',
  transitionDuration: 300,
} as const;

// Section Configuration
export const SECTION_CONFIG = {
  hero: { id: 'hero', title: 'Hero' },
  about: { id: 'about', title: 'About Me' },
  experience: { id: 'experience', title: 'Professional Experience' },
  projects: { id: 'projects', title: 'Featured Projects' },
  skills: { id: 'skills', title: 'Technical Expertise' },
  education: { id: 'education', title: 'Education' },
  contact: { id: 'contact', title: "Let's Connect" },
} as const;

// UI Configuration
export const UI_CONFIG = {
  breakpoints: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  },
  spacing: {
    xs: 0.5,
    sm: 1,
    md: 2,
    lg: 4,
    xl: 6,
    '2xl': 8,
  },
  borderRadius: {
    sm: 0.25,
    md: 0.5,
    lg: 0.75,
    xl: 1,
    full: 9999,
  },
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  dataLoadFailed: 'Failed to load site data. Please refresh the page.',
  networkError: 'Network error. Please check your connection.',
  validationError: 'Invalid data received from server.',
  unknownError: 'An unexpected error occurred.',
} as const;

// Loading Messages
export const LOADING_MESSAGES = {
  default: 'Loading...',
  data: 'Loading content...',
  fetching: 'Fetching data...',
} as const;

// Social Media Configuration
export const SOCIAL_CONFIG = {
  platforms: {
    github: { name: 'GitHub', color: '#333' },
    linkedin: { name: 'LinkedIn', color: '#0077b5' },
    twitter: { name: 'Twitter', color: '#1da1f2' },
  },
} as const;

// Accessibility Configuration
export const A11Y_CONFIG = {
  skipLinkTarget: 'main-content',
  focusVisibleClass: 'focus-visible',
  reducedMotionQuery: '(prefers-reduced-motion: reduce)',
} as const;
